<template>
  <router-view />
</template>

<script>
export default {
  name: 'TransferAllowanceIndex'
}
</script>
